module.exports = __webpack_public_path__ + "media/images/prevention_form/lebenskompetenz-96fc1fdadb3013f261edf3cd56e0ffe4.svg";